/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "DigitalWalletSnapshot": {
                    "fields": {
                      "apple": {
                        "type": "squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet",
                        "id": 1
                      }
                    },
                    "nested": {
                      "AppleWallet": {
                        "fields": {
                          "existingPasses": {
                            "type": "squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Pass": {
                            "fields": {
                              "cardToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "canBeAddedToRemote": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "platform": {
                        "oneof": ["apple"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.AppleWallet && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.AppleWallet?.nested?.Pass) {
  $root.addJSON(jsonData);
}

/**
 * Known cards already added to the client device.
 *
 * Used to determine if the card can be added the the device's digital wallet or paired devices.
 *
 * SOURCE DigitalWalletSnapshot @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 13:1
 */
export const DigitalWalletSnapshot = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot');
fixType(DigitalWalletSnapshot);
Builder.createAndAttachToType(DigitalWalletSnapshot);
/**
 * SOURCE AppleWallet @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 17:3
 */
DigitalWalletSnapshot.AppleWallet = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet');
fixType(DigitalWalletSnapshot.AppleWallet);
Builder.createAndAttachToType(DigitalWalletSnapshot.AppleWallet);
/**
 * SOURCE Pass @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 25:5
 */
DigitalWalletSnapshot.AppleWallet.Pass = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass');
fixType(DigitalWalletSnapshot.AppleWallet.Pass, {
  cardToken: {
    notEmpty: true
  },
  canBeAddedToRemote: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSnapshot.AppleWallet.Pass);